import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import numeral from 'numeral'
import React from 'react'
import {IoArrowDown, IoArrowUp, IoEyeOutline, IoRemoveOutline,} from 'react-icons/io5'
import {branch, compose, fromRenderProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {renderOwnChild, renderSelf} from 'views/Shared'
import WorkspaceContext from '../WorkspaceContext';
import {InsightsBlockHeader} from './WorkspaceInsights'

const MetaItem = ({icon, title, value, description, border, children, render = renderSelf}) => (
    <div className={classNames('p-3 flex flex-col background shadow-lg rounded-xl relative', border)}>
        <span className="text-xs text-gray-500 uppercase tracking-wider">
            {title}
        </span>
        <div className="my-2 flex flex-col leading-snug">
            {render(
                <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold uppercase">
                        {value?.toString()?.length > 9 ? numeral(value).format('0 a').toLocaleString() : value.toLocaleString()}
                    </span>
                    {children}
                    <div style={{ top: '50%', transform: 'translate(0, -50%)' }} className="absolute right-10">
                        {icon}
                    </div>
                </div>,
                {value}
            )}
        </div>
        <span className="text-xs text-color-300 tracking-wider">
            {description}
        </span>
    </div>
)

const renderDiff = ([current_value = 0, old_value = 0]) => {
    const diff = Number(current_value) - Number(old_value)

    const _value = diff / (Number(old_value) === 0 ? diff : Number(old_value))

    const percent = numeral(_value).format(
        (_value * 100) % 1 === 0 ? '0%' : '0.00%'
    )

    return (
        <div className="flex items-center justify-center gap-2">
            {diff > 0 ? (
                <IoArrowUp className="text-green-500 text-xs"/>
            ) : diff < 0 ? (
                <IoArrowDown className="text-red-500 text-xs"/>
            ) : (
                <IoRemoveOutline className="text-color-400 text-xs"/>
            )}

            {current_value !== old_value && Number(current_value) !== 0 && (
                <span
                    className={classNames(
                        "font-medium tracking-wider",diff > 0
                            ? 'text-green-500 text-xs'
                            : diff < 0
                            ? 'text-red-500 text-xs'
                            : 'text-color-400 text-xs'
                    )}>
          {percent}
        </span>
            )}
        </div>
    )
}

const defaultFieldParams = [
    {
        name: 'total',
        label: 'total',
        extra_name: 'total_prev',
        icon: <IoEyeOutline/>,
        render: (child, params) => child,
    },
]

const WorkspaceInsightsMetaSummary = ({
                                          style,
                                          summary,
                                          className,
                                          isLoading = false,
                                          title = 'overview',
                                          Wrapper = renderOwnChild,
                                          Header = InsightsBlockHeader,
                                          field_params = defaultFieldParams,
                                      }) => (
    <Wrapper>
        <Header title={title}/>
        {_.isEmpty(field_params) ? (
            <EmptyHolder/>
        ) : (
            <div
                style={style}
                className={className}>
                <Translate>
                    {(t) =>
                        Array.from(field_params).map(
                            ({name, icon, label, description, border, extra_name, render = (child, params) => child, value : _value}, index) => {
                                const value = _.get(summary, name, _value || 0)
                                return (
                                    <MetaItem
                                        key={index}
                                        icon={icon}
                                        value={value}
                                        title={t(label)}
                                        render={render}
                                        description={description}
                                        border={border}>
                                        {!!_.get(summary, extra_name) && (
                                            <span className="font-light flex items-center italic ">
                                                {renderDiff([value, _.get(summary, extra_name)])}
                                            </span>
                                        )}
                                    </MetaItem>
                                )
                            }
                        )
                    }
                </Translate>
            </div>
        )}
    </Wrapper>
)

export default ({summary, ...props}) =>
    compose(
        fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
            item: organization,
        })),
        branch(
            ({item}) => _.isEmpty(item),
            () => () => <ContentNotFound/>
        )
    )(WorkspaceInsightsMetaSummary)({
        summary,
        ...props,
    })
